import * as React from 'react';

interface ILineItemProps {
    description: string;
    price: string;
    priceTypeDescription: string;
    onSelect: (e: any) => void;
    onRemove: (e: any) => void;
    isSelected: boolean;
    priceFeeHeading?: string;
    fee?: string;
    baseTicketCost?: string;
    displaySeatFee?: boolean;
}

// Cart line item
const LineItem: React.SFC<ILineItemProps> = (props) => {
    const { description, price, priceTypeDescription, onSelect, onRemove, isSelected, priceFeeHeading, fee, baseTicketCost } = props;
    const useTagClose = '<use xlink:href="#icon-close" />';

    return (
        <li className={"cart-item" + (isSelected ? " active" : "")}>
            <button type="button" className="cart-item-action" onClick={onRemove}>
                {/*TODO: dynamic text*/}
                <span className="visually-hidden">Remove Seat {description}</span>
                <svg className="cart-mini-close" dangerouslySetInnerHTML={{ __html: useTagClose }} />
            </button>
            <div className="cart-item-content">
                {
                    onSelect !== null ?
                        <button className="cart-mini-item-button" type="button" onClick={onSelect}>{description}</button>
                        :
                        <span className="cart-mini-item-text">{description}</span>
                }
                <p className="cart-item-price-info">
                    <span>{priceTypeDescription}</span>
                    <span>{price}</span>
                </p>
                {
                    props.displaySeatFee ?
                        <div className="small-italic">
                            <p className="cart-item-price-info">{priceFeeHeading}</p>
                            <p className="cart-item-price-info" dangerouslySetInnerHTML={{ __html: baseTicketCost }} />
                            <p className="cart-item-price-info" dangerouslySetInnerHTML={{ __html: fee }} />
                        </div>
                        : null
                }
            </div>
        </li>
    );
}

export default LineItem;